<template lang="html">
    <v-form v-model="isValid" ref="form">
        <v-layout wrap>
            <v-flex xs12>
                <v-select
                    label="Gestionnaire"
                    autocomplete
                    required
                    chips
                    clearable
                    :items="managers"
                    item-text="fullName"
                    item-value="id"
                    :rules="rules.manager_id"
                    v-model="manager_id"
                    autofocus
                    >

                    <template slot="selection" slot-scope="data">
                        <v-chip>
                            <avatar size="3rem" :item="data.item"></avatar>
                            {{ data.item.first_name }} {{ data.item.last_name }}
                        </v-chip>
                    </template>

                    <template slot="item" slot-scope="data">
                        <template v-if="typeof data.item === 'object'">
                            <avatar size="3rem" :item="data.item"></avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ data.item.first_name }} {{ data.item.last_name }}</v-list-tile-title>
                            </v-list-tile-content>
                        </template>
                    </template>

                </v-select>
            </v-flex>
       </v-layout>
    </v-form>
</template>

<script>
    import Avatar from '../../../components/avatar/Avatar.vue'
    export default {
        components: { Avatar },

        data() {
            return {
                title:      'Changer le Gestionnaire',
                icon:       'mdi-bullhorn',

                isValid:    false,

                manager_id   : '',

                rules: {
                    manager_id: [
                    (v) => !!v || 'Gestionnaire obligatoire',
                    ],
                },

                managers: []
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                if(this.$refs.form.validate()) {
                    this.axios.put(`/api/projects/${this.$store.state.single.data.id}`, { user_id: this.manager_id })
                        .then(response => {
                            this.$eventHub.$emit('close-modal')
                            this.$store.dispatch('updateSingleData', { key:'user_id', value:this.manager_id })
                            this.$store.dispatch('updateSingleData', { key:'user', value: this.$_.find(this.managers,m => m.id == this.manager_id)})
                        })
                        .catch(error => {
                            console.log(error.response.data)
                        })
                } else {
                    return false
                }
            }
        },

        mounted() {
            this.manager_id = this.$store.state.single.data.user_id

            this.axios.get('/api/users')
                .then(response => {
                    this.managers = response.data
                    this.managers.forEach(item => {
                           let obj = item
                           obj.fullName = item.first_name + ' ' + item.last_name
                           this.managers.push(obj)
                       })
                })
                .catch(error => {
                    console.log(error.response.data)
                })
        }

    }
</script>

<style lang="stylus">
.chip__content {
    .avatar {
        margin-right: 0
    }
}
</style>



// WEBPACK FOOTER //
// src/views/projects/single/UpdateManager.vue